<template>
	<div>
		<b-dropdown toggle-class="drv-btn bg-white rounded-pill" text="Filters">
			<template v-if="dropdownOptions.length">
				<b-dropdown-item
					v-for="(optionItem, optionIndex) in dropdownOptions"
					@click.prevent="activeFilterIndex = optionIndex"
					:key="`filter-${optionItem}`"
					href
					>{{ optionItem }}</b-dropdown-item
				>
			</template>
			<b-dropdown-text v-else>Please wait..</b-dropdown-text>
		</b-dropdown>

		<b-modal
			v-model="showModal"
			@hidden="activeFilterIndex = -1"
			:title="modalTitle"
			body-class="py-0 px-4"
			footer-class="p-4 d-flex align-items-center justify-content-between"
			class="drv-modal"
		>
			<VueOptionsList
				v-model="selectedItems"
				:options="checklistOptions"
			/>

			<template #modal-footer>
				<b-button
					v-if="selectedItems.length"
					@click.prevent.stop="selectedItems = []"
					variant="primary"
					outlined
					>Clear</b-button
				>
				<b-button
					@click.prevent.stop="handleSave"
					variant="primary"
					class="ml-auto"
					>Save</b-button
				>
			</template>
		</b-modal>
	</div>
</template>

<script>
import moment from "moment";

export default {
	name: "drv-filters",
	props: {
		value: Object,
		filters: {
			type: Array,
			validator(values) {
				if (!values.length) return true;

				return Object.keys(values[0]).includes("name", "options");
			},
		},
	},
	data() {
		return {
			showModal: false,
			activeFilterName: "",
			activeFilterIndex: -1,
			selectedItems: [],
		};
	},
	computed: {
		modalTitle() {
			return this.activeFilterName.replaceAll("_", " ") || `Filters`;
		},
		dropdownOptions() {
			return this.filters.map((item) => item.label);
		},
		checklistOptions() {
			if (0 > this.activeFilterIndex) return [];

			const listOptions = this.filters[
				this.activeFilterIndex
			].options.sort((a, b) => {
				if ("Reporting_Period_End_Date" === this.activeFilterName)
					return moment(b, "MM-DD-YYYY") - moment(a, "MM-DD-YYYY");
				else return 0;
			});

			return listOptions.filter((item) => {
				return "All" == item ? false : true;
			});
		},
	},
	methods: {
		handleSave() {
			const emitData = {
				name: this.activeFilterName,
				value: this.selectedItems,
			};

			if ("Reporting_Period_End_Date" === emitData.name) {
				const startMonth = moment().startOf("month");
				const endMonth = moment().endOf("month");

				if (this.selectedItems.length) {
					if ("current-month" === this.selectedItems[0]) {
						emitData.value = `${startMonth.format(
							"MM-DD-YYYY"
						)},${endMonth.format("MM-DD-YYYY")}`;
					} else if ("last-month" === this.selectedItems[0]) {
						emitData.value = `${startMonth
							.subtract(1, "month")
							.format("MM-DD-YYYY")},${endMonth
							.subtract(1, "month")
							.format("MM-DD-YYYY")}`;
					}
				}
			}

			this.$emit("filter", emitData);

			this.showModal = false;
		},
	},
	watch: {
		value: {
			deep: true,
			handler(newValue) {
				if (newValue && undefined !== newValue[this.activeFilterName])
					this.selectedItems =
						newValue[this.activeFilterName].value || [];
				else this.selectedItems = [];
			},
		},
		activeFilterIndex(newValue) {
			if (0 <= newValue) {
				this.activeFilterName = this.filters[newValue].name;
				this.showModal = true;
			} else {
				this.activeFilterName = "";
				this.selectedItems = [];
			}
		},
		selectedItems(newValue) {
			if ("Reporting_Period_End_Date" !== this.activeFilterName) return;

			if (1 < newValue.length) {
				const checkedItem = newValue[newValue.length - 1];

				["current-month", "last-month"].forEach((item) => {
					if (item === checkedItem) {
						this.selectedItems = [item];
					} else {
						const itemIndex = this.selectedItems.indexOf(itemIndex);

						if (0 <= itemIndex)
							this.selectedItems.splice(itemIndex, 1);
					}
				});
			}
		},
	},
};
</script>
